import React from 'react';
import classnames from 'classnames';

import { AlertIcon } from 'components';
import Icon from 'assets/icons';

import styles from './AccessOverviewHeading.module.scss';

interface AccessOverviewHeadingProps {
  alternate?: boolean;
  className?: string;
  title: string;
  subtitle?: string;
  complete?: boolean;
}

export const AccessOverviewHeading = ({
  alternate,
  className,
  title,
  subtitle,
  complete = false,
}: AccessOverviewHeadingProps) => {
  function backgroundColor() {
    if (complete) {
      return 'Green';
    } else if (alternate) {
      return 'Yellow';
    } else {
      return 'Pink';
    }
  }

  return (
    <div className={classnames(className, styles.heading)}>
      <AlertIcon
        className={styles.icon}
        bgColor={backgroundColor()}
        size="Large"
        status={complete === true ? 'Complete' : 'Incomplete'}
      />
      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
      {!complete && <Icon.ChevronThick className={styles.indicator} />}
    </div>
  );
};
